import 'whatwg-fetch';

const parseJSON = async (response: Response) => {
    let data;
    try {
        data = await response.json();
    } catch (ex) {
        if (process.env.NODE_ENV === 'development') {
            console.warn('Error parsing json.', ex);
        }
    }

    return typeof data !== 'undefined' ? data : {};
};

const createValidationErrors = (data: {}) =>
    data &&
    Object.keys(data).reduce((errors, key) => {
        const message = (data as any)[key];
        const path = key.split('.').map((x) => x.charAt(0).toLowerCase() + x.slice(1));

        let current = errors;
        for (let i = 0; i < path.length - 1; i++) {
            let next = (current as any)[path[i]];
            if (!next) {
                next = {};
                (current as any)[path[i]] = next;
            }

            current = next;
        }

        (current as any)[path[path.length - 1]] = message;

        return errors;
    }, {});

export const formatError = (message: string[], errors?: {}) => {
    return { error: message, ...errors };
};

export const validateResponse = async (response: Response) => {
    if (response.status >= 200 && response.status < 300) {
        return;
    }

    if (response.status === 404 || response.status === 500) {
        const data = await parseJSON(response);
        throw formatError(data.error);
    }

    if (response.status === 403) {
        throw formatError(['Neturite prieigos prie šio puslapio.']);
    }

    if (response.status === 400) {
        const data = await parseJSON(response);
        const errors = createValidationErrors(data);
        console.log('ERRORS IN API CLIENT', errors);
        throw formatError(['Vykdant užklausą įvyko klaida.'], errors);
    }

    throw formatError(['Vykdant užklausą įvyko klaida.']);
};

export const fixUrl = (url: string) => (url.startsWith('/') ? `${process.env.PUBLIC_URL}${url}` : url);

const request = async (method: 'GET' | 'POST' | 'PUT' | 'DELETE', url: string, data?: {}) => {
    const token = await window['getToken']?.();
    const options = {
        method: method,
        headers: { 
            'Content-Type': 'application/json', 
            Accept: 'application/json' 
        },
        body:
            typeof data !== 'undefined'
                ? containsFileOrBlob(data)
                    ? (() => {
                          return getFormDataModel(data);
                      })()
                    : JSON.stringify(data)
                : undefined
    } as RequestInit;
    if (typeof data !== 'undefined' && containsFileOrBlob(data)) {
        const newHeadder = removeHeadderValue(options.headers as Record<string, string>);
        options.headers = newHeadder;
    }

    if (token) {
        options.headers!['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(fixUrl(url), options);
    await validateResponse(response);

    return await parseJSON(response);
};

const removeHeadderValue = (headers: Record<string, string>) => {
    const newHeaders = Object.keys(headers).reduce((object, key) => {
        if (key !== 'Content-Type') {
            object[key] = headers[key];
        }
        return object;
    }, {});
    return newHeaders;
};

const containsFileOrBlob = (data: {}): boolean => {
    if ('failai' in data) {
        return true;
    }
    return Object.keys(data)
        .map((key) =>
            data[key]
                ? data[key].constructor.name === 'FileList' || data[key].constructor.name === 'File' || data[key].constructor.name === 'Blob'
                : false
        )
        .some((value) => value === true);
};

const getFormDataModel = (data: {}): FormData => {
    const formData: FormData = new FormData();
    Object.keys(data).forEach((key) => {
        if ((data[key] && data[key].constructor && data[key].constructor.name === 'FileList') || Array.isArray(data[key])) {
            for (let index = 0; index < data[key].length; index++) {
                formData.append(firstToUppercase(key), data[key][index]);
            }
        } else {
            formData.append(firstToUppercase(key), data[key] ?? '');
        }
    });
    return formData;
};

export const firstToUppercase = (name?: string): string => {
    return name != null ? name.charAt(0).toUpperCase() + name.slice(1) : '';
};

export default {
    get: (url: string) => request('GET', url),
    post: (url: string, data?: {}) => request('POST', url, data),
    put: (url: string, data?: {}) => request('PUT', url, data),
    delete: (url: string) => request('DELETE', url)
};
